/* eslint-disable jsx-a11y/anchor-is-valid */


import React from 'react'

const Footer = () => {
    return (
        <>
            <section class="footer">
                <div class="container">
                    <div class="logo">
                        <img src="/assets/images/logo.png" alt="footerlogo" />
                    </div>
                    <div class="row">
                        <div class="footer-nav">
                            <ul>
                                <li><a href="#" title="Home">Home</a></li>
                                <li><a href="#" title="Abou tus">Abou tus</a></li>
                                <li><a href="#" title="Services">Services</a></li>
                                <li><a href="#" title="Testimonials">Testimonials</a></li>
                                <li><a href="#" title="Our Team">Our Team</a></li>
                                <li><a href="#" title="Pricing">Pricing</a></li>
                                <li><a href="#" title="Appointment">Appointment</a></li>
                                <li><a href="#" title="Our Gallery">Our Gallery</a></li>
                                <li><a href="#" title="Latest Blog">Latest Blog</a></li>
                                <li><a href="#" title="Location">Location</a></li>
                            </ul>
                        </div>
                        <div class="subscribe-us clearfix">
                            <h5>Subscribe us</h5>
                            <p>Subscribe to our Newsletter to get first Gift voucher by Unique Barber</p>
                            <div class="subscribe-email">
                                <input type="text" name="Enter your email" placeholder="Enter your email" />
                                <input type="submit" name="submit" />
                            </div>
                            <div class="social-ic">
                                <ul>
                                    <li><a href="#" title="Facebook"><i class="icofont icofont-social-facebook"></i></a></li>
                                    <li><a href="#" title="Twitter"><i class="icofont icofont-social-twitter"></i></a></li>
                                    <li><a href="#" title="Google plus"><i class="icofont icofont-social-google-plus"></i></a></li>
                                    <li><a href="#" title="Pintrest"><i class="icofont icofont-social-pinterest"></i></a></li>
                                    <li><a href="#" title="youtube"><i class="icofont icofont-social-youtube-play"></i></a></li>
                                </ul>
                            </div>
                            <p class="copyright">&copy; 2017 Made by <span>KAZ Themes</span></p>
                        </div>
                    </div>
                    <a href="#top" class="scroll-top">go top</a>
                </div>
            </section>

        </>
    )
}

export default Footer
